module.exports = "<div  class=\"alert alert-info\" [ngClass]=\"{'active': error }\">\n  <h1>{{ErrorMsg}}</h1>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/components/display-error/display-error.component.html
// module id = ../../../../../src/app/components/display-error/display-error.component.html
// module chunks = main